import type { AiImageTask, AiMusicTask, AiVideoTask, CheckpointTask } from "schema/agent";

export function isImageTask(task: CheckpointTask): task is AiImageTask {
  return task.type === "image";
}

export function isVideoTask(task: CheckpointTask): task is AiVideoTask {
  return task.type === "video";
}

export function isMusicTask(task: CheckpointTask): task is AiMusicTask {
  return task.type === "music";
}
